
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_blog",
      function () {
        return require("private-next-pages/_blog.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_blog"])
      });
    }
  